module.exports = __webpack_public_path__ + "img/OMD.e0e91810.png";